import script from "./ButtonHiddenPages.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonHiddenPages.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonHiddenPages.vue?vue&type=style&index=0&id=401da85c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-401da85c"]])

export default __exports__